import React from 'react'
import propTypes from 'prop-types';

export const Chips = React.memo(({ variant, text, className, onClick ,loader ,loaderText,icon }) => {
    const variants = {
        'chip-orange': 'chip-orange',
        'chip-cyan': 'chip-cyan',
        'chip-pink': 'chip-pink',
        'chip-salmon': 'chip-salmon',
        'chip-teal': 'chip-teal',
        'chip-deep-purple': 'chip-deep-purple',
        'chip-success': 'chip-success',
        'chip-danger': 'chip-danger', 
    }

    return <div className={`chip ${variants[variant]} ${className}`} onClick={onClick}>{loader ? loaderText:text} {icon}</div>
})

Chips.propTypes = {
    text: propTypes.string,
    onClick: propTypes.func,
    loader: propTypes.bool,
    variant: propTypes.string,
    className: propTypes.string,
    loaderText: propTypes.string,
    icon: propTypes.any,
}

Chips.defaultProps = {
    text: '',
    onClick: () => {},
    loader: false,
    variant: 'chip-orange',
    className: '',
    loaderText: 'Loading...',
    icon:<></>
}